import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Tab, TabList, Tabs } from '@carbon/react';
import { useAuthSession } from 'src/hooks/useAuthSession';

const Admin = () => {
  const { t } = useTranslation();
  const { platformRole } = useAuthSession();
  const navigate = useNavigate();
  const location = useLocation();

  const routes = useMemo(
    () => [
      { label: 'admin.tabs.organizations', url: '/admin' },
      { label: 'admin.tabs.users', url: '/admin/users' },
    ],
    []
  );

  const activeTabIndex = useMemo(
    () =>
      Math.max(
        0,
        routes.findIndex(
          (route) =>
            location.pathname === route.url ||
            location.pathname === `${route.url}/` ||
            (route.url === '/admin' && location.pathname === '/admin/organizations')
        )
      ),
    [location.pathname, routes]
  );

  if (platformRole !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="store-settings-page">
      <div className="store-settings-page__header">
        <h1 className="store-settings-page__heading">{t('admin.title')}</h1>
      </div>
      <Tabs selectedIndex={activeTabIndex}>
        <TabList className="tabs-group" aria-label="Tab navigation" contained>
          {routes.map((route) => (
            <Tab key={route.url} onClick={() => navigate(route.url)}>
              {t(route.label)}
            </Tab>
          ))}
        </TabList>
      </Tabs>
      <div className="store-settings-page__main-content">
        <Outlet />
      </div>
    </div>
  );
};

export default Admin;
